import { FilterBarClearFiltersButton } from '../FilterBarClearFiltersButton'
import { FilterBarSaveTemplateButton } from '../FilterBarSaveTemplateButton'
import { FilterBarShareTemplateButton } from '../FilterBarShareTemplateButton'

import * as styles from './FilterBarItems.module.css'

function FilterBarItems({
  ClearFiltersButton = FilterBarClearFiltersButton,
  SaveTemplateButton = FilterBarSaveTemplateButton,
  ShareTemplateButton = FilterBarShareTemplateButton,
  canViewFilterTemplate,
  controlClassName = styles.control,
  isSkeleton,
  items,
  onClear,
  onSaveTemplate,
  onShare,
}) {
  return (
    <>
      {items}
      <div className={controlClassName}>
        {SaveTemplateButton && canViewFilterTemplate ? (
          <SaveTemplateButton
            canViewFilterTemplate={canViewFilterTemplate}
            isSkeleton={isSkeleton}
            onSaveTemplate={onSaveTemplate}
          />
        ) : null}
        {ShareTemplateButton ? (
          <ShareTemplateButton isSkeleton={isSkeleton} onShare={onShare} />
        ) : null}
        {ClearFiltersButton ? (
          <ClearFiltersButton isSkeleton={isSkeleton} onClick={onClear} />
        ) : null}
      </div>
    </>
  )
}

export default FilterBarItems
